import { ColumnConfig } from "@/components/tables/ReusableTablePage";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "date-fns";

interface Order {
  id: string;
  order_number: string;
  status: string;
  customer_id: string;
  total_amount: number;
  currency: string;
  created_at: string;
  updated_at: string;
  confirmed_at?: string;
  shipped_at?: string;
  delivered_at?: string;
  cancelled_at?: string;
  notes?: string;
}

const statusColors: Record<string, string> = {
  draft: "secondary",
  confirmed: "default",
  processing: "warning",
  shipped: "info",
  delivered: "success",
  cancelled: "destructive"
};

export const getOrdersColumns = (): ColumnConfig[] => [
  {
    key: "order_number",
    header: "Order Number",
    sortable: true,
    render: (value) => (
      <div className="font-medium">
        {value || '-'}
      </div>
    ),
  },
  {
    key: "status",
    header: "Status",
    sortable: true,
    render: (value) => {
      const status = value as string;
      return (
        <Badge variant={statusColors[status] as any || "secondary"}>
          {status ? status.charAt(0).toUpperCase() + status.slice(1) : 'Unknown'}
        </Badge>
      );
    },
  },
  {
    key: "total_amount",
    header: "Total",
    sortable: true,
    render: (value, row) => {
      const amount = parseFloat(value as string) || 0;
      const currency = (row as Order).currency || "AUD";
      return (
        <div className="font-medium">
          {new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: currency,
          }).format(amount)}
        </div>
      );
    },
  },
  {
    key: "customer_id",
    header: "Customer ID",
    sortable: false,
    render: (value) => (
      <div className="text-sm text-muted-foreground font-mono">
        {value ? String(value).slice(0, 8) + '...' : '-'}
      </div>
    ),
  },
  {
    key: "created_at",
    header: "Created",
    sortable: true,
    render: (value) => {
      return (
        <div className="text-sm">
          {value ? formatDate(new Date(value as string), "MMM dd, yyyy") : "N/A"}
        </div>
      );
    },
  },
  {
    key: "confirmed_at",
    header: "Confirmed",
    sortable: true,
    render: (value) => {
      return (
        <div className="text-sm text-muted-foreground">
          {value ? formatDate(new Date(value as string), "MMM dd, yyyy") : "-"}
        </div>
      );
    },
  },
  {
    key: "shipped_at",
    header: "Shipped",
    sortable: true,
    render: (value) => {
      return (
        <div className="text-sm text-muted-foreground">
          {value ? formatDate(new Date(value as string), "MMM dd, yyyy") : "-"}
        </div>
      );
    },
  },
  {
    key: "delivered_at",
    header: "Delivered",
    sortable: true,
    render: (value) => {
      return (
        <div className="text-sm text-muted-foreground">
          {value ? formatDate(new Date(value as string), "MMM dd, yyyy") : "-"}
        </div>
      );
    },
  },
];